import { render, staticRenderFns } from "./ModalCoupon.vue?vue&type=template&id=3f09dc4d&"
import script from "./ModalCoupon.vue?vue&type=script&lang=ts&"
export * from "./ModalCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports